import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface CtaClickParams {
  ctaLabel: string;
  ctaSection: string;
  ctaComponent: string;
  ctaElementId: string;
  hu: string;
}

@Injectable({ providedIn: 'root' })
export class AnalyticsTagService {
  constructor(private router: Router) {}

  trackCtaClick(params: CtaClickParams): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cta_click',
      cta_label: params.ctaLabel,
      cta_section: params.ctaSection,
      cta_component: params.ctaComponent,
      cta_element_id: params.ctaElementId,
      page_path: this.router.url,
      hu: params.hu,
    });
  }
}
